<template>
  <page>
    <owner-sidebar slot="sidebar"/>
    <span slot="header">Edit Organization</span>
    <span slot="breadcrumbs">
      <b-breadcrumb :items="breadcrumbs"/>
    </span>

    <form-wrapper>
      <b-form class="form-inline-fields" @submit="onSubmit">
        <b-form-group>
          <label for="email-input">Organization ID</label>
          <input
            :value="organization.id"
            disabled
            class="form-control"
            type="text"/>
        </b-form-group>
        <b-form-group>
          <label for="name-input">Name</label>
          <input
            v-validate="'organizationName'"
            id="name-input"
            :disabled="saving"
            :class="{ 'is-invalid' : errors.has('name') || apiErrors.name.length }"
            :value="fields.name === null ? organization.name : fields.name"
            class="form-control"
            type="text"
            name="name"
            @input="setName"/>
          <validation-errors :validation-errors="[errors.first('name')]"/>
          <validation-errors v-if="!errors.has('name')" :validation-errors="apiErrors.name"/>
        </b-form-group>

        <b-form-group>
          <b-form-checkbox
            id="enable-bioreq"
            v-model="enablebioreq"
            name="enable-bioreq-checkbox"
            value="1"
            unchecked-value="0"
            @input="setEnableBioreq"
          >
            Enable Bioreq
          </b-form-checkbox>
        </b-form-group>

        <b-form-group class="form-buttons">
          <b-button :disabled="saving" variant="secondary" @click="$router.push({name: 'organizations'})">
            Cancel
          </b-button>
          <b-button :disabled="disabled" type="submit" variant="primary">
            Confirm
            <span v-if="saving"><i class="fas fa-spinner fa-spin"></i></span>
          </b-button>
        </b-form-group>

        <form-success :success="success" class="form-alert">Organization Updated!</form-success>
      </b-form>
    </form-wrapper>
  </page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import page from '../../../templates/page'
import ownerSidebar from '../../../sidebar/owner'
import passwordRules from '../../../common/form/password-rules'
import formWrapper from '../../../common/form/form-wrapper'
import validationErrors from '../../../common/form/validation-errors'
import formSuccess from '../../../common/form/form-success'

export default {
  components: {
    ownerSidebar,
    page,
    passwordRules,
    validationErrors,
    formWrapper,
    formSuccess
  },
  data () {
    return {
      breadcrumbs: [{
        text: 'Organizations',
        to: { name: 'organizations' }
      },
      {
        text: 'Edit',
        active: true
      }],
      enablebioreq: 0
    }
  },
  computed: {
    ...mapState('tenants/forms/update', [ 
      'apiErrors',
      'fields',
      'success',
      'saving'
    ]),
    ...mapState('tenants', {
      organization: 'current'
    }),
    disabled () {
      return this.errors.any() || (!this.fields.name && (!this.fields.enableBioreq || this.fields.enableBioreq == 0)) || this.saving
    }
  },
  created() {
    this.$store.commit('tenants/forms/update/resetState')
  },
  methods: {
    ...mapActions({
      updateTenant: 'tenants/update'
    }),
    onSubmit (e) {
      e.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updateTenant({id: this.organization.id})
        }
      })
    },
    setName (e) {
      this.$store.commit('tenants/forms/update/setField', {
        field: 'name',
        value: e.target.value
      })
    },
    setEnableBioreq () {

      if (!this.fields.name) {
        this.$store.commit('tenants/forms/update/setField', {
          field: 'name',
          value: this.organization.name
        })
      }

      this.$store.commit('tenants/forms/update/setField', {
        field: 'enableBioreq',
        value: this.enablebioreq
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/organizations/edit.vue